module.exports = __webpack_public_path__ + "static/1st_floor_1-615a78aa10978101598ac38107ea7620.jpg";